let service = {};

// 表单提交
service.submitForm = function (vm, url,targetRouter) {
    if (vm.editFlag) {
        vm.fullscreenLoading = true;
        vm.$job.editFun(vm,url, JSON.stringify(vm.formInfo), function () {
            // 去除遮罩
            vm.fullscreenLoading = false;
            vm.$router.push({
                name: targetRouter,
            })
        }, function () {
            // 去除遮罩
            vm.fullscreenLoading = false;
        });
    } else {
        vm.$job.addFun(vm,url, JSON.stringify(vm.formInfo), function () {
            // 去除遮罩
            vm.fullscreenLoading = false;
            vm.$router.push({
                name: targetRouter,
            })
        }, function () {
            // 去除遮罩
            vm.fullscreenLoading = false;
        });
    }
}

// 表单提交
service.submitFormDoFun = function (vm, url,suc) {
    if (vm.editFlag) {
        vm.fullscreenLoading = true;
        vm.$job.editFun(vm,url, JSON.stringify(vm.formInfo), function (res) {
            // 去除遮罩
            vm.fullscreenLoading = false;
            suc(res);
        }, function () {
            // 去除遮罩
            vm.fullscreenLoading = false;
        });
    } else {
        vm.$job.addFun(vm,url, JSON.stringify(vm.formInfo), function (res) {
            // 去除遮罩
            vm.fullscreenLoading = false;
            suc(res);
        }, function () {
            // 去除遮罩
            vm.fullscreenLoading = false;
        });
    }
}



// 表单formData提交
service.submitFormData = function (vm, url,params,targetRouter) {
    vm.fullscreenLoading = true;
    if (vm.editFlag) {
        vm.$job.submitFormDataPut(vm,url, params, function () {
            // 去除遮罩
            vm.fullscreenLoading = false;
            vm.$router.push({
                name: targetRouter,
            })
        }, function () {
            // 去除遮罩
            vm.fullscreenLoading = false;
        });
    } else {
        vm.$job.submitFormData(vm,url, params, function () {
            // 去除遮罩
            vm.fullscreenLoading = false;
            vm.$router.push({
                name: targetRouter,
            })
        }, function () {
            // 去除遮罩
            vm.fullscreenLoading = false;
        });
    }
}

// 表单formData提交
service.submitFormDataEdit = function (vm, url,params,targetRouter) {
    vm.fullscreenLoading = true;
    vm.$job.submitFormDataPut(vm,url, params, function () {
        // 去除遮罩
        vm.fullscreenLoading = false;
        vm.$router.push({
            name: targetRouter,
        })
    }, function () {
        // 去除遮罩
        vm.fullscreenLoading = false;
    });
}

// 表单formData提交
service.submitFormDataAdd = function (vm, url,params,targetRouter) {
    vm.fullscreenLoading = true;
    vm.$job.submitFormData(vm,url, params, function () {
        // 去除遮罩
        vm.fullscreenLoading = false;
        vm.$router.push({
            name: targetRouter,
        })
    }, function () {
        // 去除遮罩
        vm.fullscreenLoading = false;
    });
}

export default service;



// WEBPACK FOOTER //
// ./src/utils/service.js